module.exports = __webpack_public_path__ + "img/96.347e5250.jpg";